import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=bb8df392&scoped=true"
import script from "./ContentBlock.js?vue&type=script&lang=js&external"
export * from "./ContentBlock.js?vue&type=script&lang=js&external"
import style0 from "./ContentBlock.scss?vue&type=style&index=0&id=bb8df392&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8df392",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTag: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Tag/Tag.vue').default,HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default,HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
